import http from 'utils/http'

const validationToken = token => http.post(`/user/v1/sign-up/validation-token/${token}`)

const changePassword = payload => http.post('/user/v1/sign-up/change-password', payload)

const requestEmailResetPassword = payload => http.post('/user/v1/login/request-reset-password', payload)

const resetPassword = payload => http.post('/user/v1/login/reset-password', payload)

export default {
  validationToken,
  changePassword,
  requestEmailResetPassword,
  resetPassword
}



// WEBPACK FOOTER //
// ./src/services/userService.js